<template>
  <div class="index">

      <div class="common_mbx">
      您当前的位置：
      <router-link to='/index' tag='span'>
        首页
      </router-link>
      <router-link to='/our' tag='span'>
        > 我们
      </router-link>
      <template v-for='(item,index) in parent'>
        <router-link to="/our/cases/15" v-if='index==0' tag='span'>
            > {{item.name}}
        </router-link>
        <router-link :to='"/our/cases/"+item.id' v-if='index==1' tag='span'>
            > {{item.name}}
        </router-link>
      </template>
    </div>
    <div class="common_wrap">
      <div class="cases_detail">
        <p class="detail_name">{{data.title}}</p>
        <p class="detail_time">时间：{{data.updatetime | time}}</p>
        <div class="cases_detail_content">
          <img :src="domain+item.url" alt="" v-for='item in data.pictureurls'>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      data:'',
      parent:[],
      domain:''
    }
  },
  watch:{
    '$route':function(to,from){
      this.getpic()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain
    this.getpic()
  },
  methods:{
    getparent:function(id){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_parent', this.$qs.stringify({
        cid:id
      }))
      .then(response => {
        console.log(response);
        this.parent=response.data.data
        //console.log(this.parent)
        /*this.cate=response.data.cate*/
      })
      .catch(error => {
        console.log(error);
      });
    },
    getpic:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=picture', this.$qs.stringify({
        id:this.$route.params.id
      }))
      .then(response => {
        console.log(response);
        this.data=response.data.data
        this.getparent(this.data.cid)
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>

 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .detail_name{
  font-size: 24px;
  color: #000;
  margin-bottom: 24px;
  text-align: center;
 }
 .detail_time{
  font-size: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-bottom: 24px;
 }
 .cases_detail_content{
  padding: 20px 0;
 }
 .cases_detail_content img{
  max-width: 100%;
  display: block;
 }
</style>


// WEBPACK FOOTER //
// src/components/cases_detail.vue